<!--
  --
  -- 基本料金カード
  --
  -->
<template>
  <v-card>
    <v-card-title>基本料金</v-card-title>

    <v-card-text class="mt-n4">
      <c-divider/>
      <c-total-row label="基本料金 小計" :charge="charge.basic"/>
    </v-card-text>
  </v-card>
</template>

<script>
import CTotalRow from './CTotalRow'
import CDivider from './CDivider'

export default {
  name: 'CBasicCard',
  components: {
    CTotalRow,
    CDivider
  },

  computed: {
    charge () {
      return this.getters['book/charge']
    }
  }
}
</script>
